import axios from 'axios';

const API_URL =
  process.env.REACT_APP_ENV === 'local'
    ? `${process.env.REACT_APP_API_LOCAL}/google-drive/file`
    : process.env.REACT_APP_ENV === 'production'
      ? `${process.env.REACT_APP_API_PRODUCTION}/google-drive/file`
      : `${process.env.REACT_APP_API_STAGING}/google-drive/file`;

const googleDriveApi = {
  postFileToGoogleDrive(file, opportunityName) {
    return axios
      .post(API_URL, file)
      .then(response => {
        return response.data;
      })
      .catch(err => {
        throw err;
      });
  },
};

export default googleDriveApi;



// WEBPACK FOOTER //
// ./src/api/googleDrive.js